import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['hidden', 'display', 'popover']

  change(event) {
    const value = event.target.value
    if (value) {
      this.hiddenTarget.value = value
      this.displayTarget.textContent = this.#formatDate(value)
      this.#closePopover()
      this.dispatch('change', { detail: { date: value } })
    }
  }

  #closePopover() {
    if (this.hasPopoverTarget) {
      this.popoverTarget.hidePopover()
    }
  }

  #formatDate(isoDate) {
    const date = new Date(isoDate + 'T00:00:00')
    return date.toLocaleDateString(undefined, {
      month: 'short',
      day: 'numeric',
    })
  }
}
